import Vue from 'vue'
import VueResource from 'vue-resource'
import router from '@/router'
import globalMixin from '@/mixins'
import store from '@/store'

Vue.use(VueResource)
let api = process.env.BASE_URL
let hideToast = false

Vue.http.interceptors.push((request, next) => {
  let accessToken = localStorage.getItem('access_token')
  request.headers.set('content-type', 'application/json')
  let publicApis = [`${api}sessions/login`, `${api}sessions/reset_password`, `${api}sessions/forgot_password`, `${api}sessions/verify_reset_link`, `${api}signup/validate`, `${api}signup/verify_link`, `${api}signup/onboard`, `${api}users/validate_token`, `${api}users/verify`]
  if (!publicApis.includes(request.url)) {
    if (accessToken) {
      request.headers.set('Authorization', accessToken)
    } else {
      store.commit('SET_USER_LOGGED_IN', false)
      globalMixin.methods.errorToastMsg('Please login to continue')
      return request.respondWith(null)
    }
  }

  let url = new URL(request.url)
  if (`${api}sessions/logout` === `${url.origin}${url.pathname}`) {
    store.commit('SET_USER_LOGGED_IN', false)
    next()
  } else {
    next((response) => {
      let errorResponse = null
      if (response.status === 0) {
        errorResponse = 'Please check your Network Connection'
      } else if (response.status === 401) {
        switch (response.body.reason) {
          case 'UNAUTHORIZED': globalMixin.methods.errorToastMsg(response.body.message)
            store.commit('SET_USER_LOGGED_IN', false)
            break
          case 'OTP_UNVERIFIED': store.commit('SET_TARGET_PAGE', 'OTP')
            router.push({name: 'OTP'})
            break
          case 'OTP_SETUP_PENDING': store.commit('SET_TARGET_PAGE', 'OTP_SETUP')
            router.push({name: 'OTPSetup'})
            break
        }
      } else if (response.status === 500) {
        errorResponse = 'Sorry, something went wrong. Please try again later'
      } else if (!hideToast && response.status > 299) {
        let message = response.body.message
        let commonMessages = [undefined, 'success', 'error', 'failure']

        if (commonMessages.includes(message)) {
          errorResponse = 'Sorry, something went wrong. Please try again later'
        } else {
          errorResponse = response.body.message
        }
      }

      if (errorResponse) {
        globalMixin.methods.errorToastMsg(errorResponse)
        store.commit('SET_INVALID_RESPONSE_MSG', errorResponse)
      }
    })
  }
})

const beforeAPI = (options = {}) => {
  if (options.restrictToast) {
    hideToast = options.restrictToast
  }
  if (!options.noHyptoLoader) {
    store.commit('SET_HYPTO_LOADER', true)
  }
  if (options.disableButtons) {
    store.commit('SET_DISABLE_BUTTON', true)
  }
}

const afterAPI = (options = {}, response) => {
  hideToast = false
  store.commit('SET_HYPTO_LOADER', false)

  if (options.disableButtons) {
    store.commit('SET_DISABLE_BUTTON', false)
  }
  if (options.unprivilege && response.body.reason === 'UNPRIVILEGED') {
    store.commit('SET_UNPRIVILEGE_PAGE', options.unprivilege)
  }
}

const sendPost = (resource, body, options) => {
  beforeAPI(options)
  return Vue.http.post(`${api}${resource}`, body)
    .then((response) => {
      afterAPI()
      return Promise.resolve(response.body)
    }).catch((error) => {
      afterAPI(options)
      return Promise.reject(error)
    })
}

const sendPut = (resource, body, options) => {
  beforeAPI(options)
  return Vue.http.put(`${api}${resource}`, body)
    .then((response) => {
      afterAPI()
      return Promise.resolve(response.body)
    }).catch((error) => {
      afterAPI(options)
      return Promise.reject(error)
    })
}

const sendGet = (resource, params, options) => {
  beforeAPI(options)
  return Vue.http.get(`${api}${resource}`, {
    params: params
  }).then((response) => {
    afterAPI(options, response)
    return Promise.resolve(response.body)
  }).catch((error) => {
    afterAPI(options, error)
    return Promise.reject(error)
  })
}

const sendDelete = (resource, payload) => {
  store.commit('SET_HYPTO_LOADER', true)
  return Vue.http.delete(`${api}${resource}`, {body: payload})
    .then((response) => {
      store.commit('SET_HYPTO_LOADER', false)
      return Promise.resolve(response.body)
    }).catch((error) => {
      store.commit('SET_HYPTO_LOADER', false)
      return Promise.reject(error)
    })
}

const sendMultipart = (resource, body) => {
  store.commit('SET_HYPTO_LOADER', true)
  return Vue.http.post(`${api}${resource}`, body, {
    headers: { 'content-type': 'multipart/form-data' }
  }).then((response) => {
    store.commit('SET_HYPTO_LOADER', false)
    return Promise.resolve(response.body)
  }).catch((error) => {
    store.commit('SET_HYPTO_LOADER', false)
    return Promise.reject(error)
  })
}

export default {
  sendPost,
  sendPut,
  sendGet,
  sendDelete,
  sendMultipart
}
